import { ReactElement } from 'react';
import InfoCard from './InfoCard';
import Procard from './Procard';

type HeaderComponentProps = {
  sectionName: string;
  showIcon?: boolean;
  showBack?: boolean;
  subHeading?: string;
  onBackPress?: () => void;
  onClick?: () => void;
  children?: any;
  proSubscription?: boolean;
  actionButton?: () => void;
  actionButtonText?: string;
};
const descriptionOfInfoCard: {
  [key: string]: string;
} = {
  Devices:
    'The average data for each device and each parameter within the selected time range can be sorted by clicking on a parameter in row 1. It can also be filtered using the first dropdown at the top of the dashboard. Click Settings to add, update, or remove a device.',
  TimeSeries:
    'Line chart showing the average data for each parameter across all devices. Use the first dropdown at the top of the dashboard to filter it.',
  ThresholdTimeline:
    'The threshold timeline displays the threshold values for all parameters. Use the first dropdown at the top of the dashboard to filter it.',
  Insights: '',
  FloorMap:
    'Floor map widget showing the floor plan of the building for Indoor Devices and the map of the area for Outdoor Devices. Click Settings to add, update, or remove a group.',
  Data: 'The average data of the parameter across all devices can be filtered using the dropdown at the top of the dashboard. Click Settings to change the card position.',
  Alerts: 'Alerts widget showing the alerts'
};

/**
 * Header component for displaying section names with additional information.
 * @param props - The props object containing sectionName and icon.
 * @returns  A React element representing the Header component.
 */
export default function Header(props: HeaderComponentProps): ReactElement {
  const {
    sectionName,
    showIcon = false,
    subHeading,
    showBack,
    onBackPress,
    onClick,
    children,
    proSubscription,
    actionButton,
    actionButtonText
  } = props;
  const description = descriptionOfInfoCard[sectionName.split(' ').join('')] || '';

  return (
    <div className="pb-1 border-b border-b-gray-200 dark:border-b-gray-900 w-full">
      <div
        onClick={() => (onClick ? onClick() : null)}
        role="button"
        tabIndex={0}
        onKeyDown={() => (onClick ? onClick() : null)}
        className={`flex gap-2 items-center ${onClick && 'cursor-pointer'}`}
      >
        {showBack && (
          <button
            onClick={onBackPress}
            type="button"
            className="material-icons-outlined text-gray-400"
          >
            navigate_before
          </button>
        )}
        <p className="text-base font-medium text-gray-400  cursor-default">{sectionName}</p>
        <div className="relative cursor-pointer group text-gray-400 flex justify-start">
          {showIcon ? (
            <span className="material-icons-outlined text-base leading-4 text-gray-400">info</span>
          ) : (
            ''
          )}
          {/* TODO:Have to fix height and width of the below div */}
          <div className="absolute z-10 transition-all left-[-0.9rem] top-3 duration-0 scale-0 group-hover:scale-100 min-w-[17rem]">
            <InfoCard
              buttonText={actionButtonText}
              title={sectionName}
              description={description}
              buttonFunction={actionButton}
            />
          </div>
        </div>
        {proSubscription && <Procard />}
        <div className="grow flex justify-end cursor-default">{children}</div>
      </div>
      <p className="text-gray-400 dark:text-gray-400 font-normal text-xs text-start pt-1">
        {subHeading}
      </p>
    </div>
  );
}
